.card {
    cursor: pointer;
    width: 100%;
    display: flex;
}

.content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: var(--exo-color-font);
}

.topRow {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.iconWrap {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

:global(.ex-theme-dark) .iconWrap {
    background: #f0f0f0;
    border: 1px solid rgba(0, 0, 0, 0.06);
}

.enabledDot {
    color: var(--exo-color-background-success-strong);
    background: var(--exo-color-background-success);
    border-radius: 50%;
}

.disabledDot {
    color: var(--exo-color-border-secondary);
}

.name {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    word-break: break-word;
}

.idp {
    font-size: 12px;
    color: var(--exo-color-font-secondary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
